import { PropsWithChildren, SyntheticEvent } from 'react';
import { observer } from 'mobx-react-lite';
import { getDialog } from './use-dialog';

export type DialogWrapperProps = PropsWithChildren<any> & {
  id: string;
  preventCancel?: boolean;
  showCloseButton?: boolean;
  // isOpen?: boolean;
}

/*
  Simple HTML Dialog wrapper that needs to be used with the HTMLDialogElement methods (showModal(), close(), etc.).
  https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/dialog
  Opening & closing could be controlled using React state <dialog open={isOpen}> but then you'd need to add in the
  backdrop and centering styles manually, plus ensure it's positioned on top of other content, & potentially
  over the menu in certain circumstances.
*/
export const DialogWrapper = observer<DialogWrapperProps>((props) => {
  const { id, children, preventCancel = true, showCloseButton = true} = props;

  const onClose = () => {
    const dialog = getDialog(id);

    if (dialog) {
      dialog.close();
    }
  }

  const onCancel = (e: SyntheticEvent<HTMLDialogElement>) => {
    if (preventCancel) {
      e.preventDefault();
    }
  }

  return (
    <dialog id={id} className="dialog-wrapper" onCancel={onCancel}>
      {showCloseButton && <button onClick={onClose} type="button">
        <i className="icon-close"></i>
      </button>}

      {children}
    </dialog>
  );
});

export default DialogWrapper;